import React from 'react';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/carousel.css';
import {Carousel} from 'react-responsive-carousel';


export default function Disney() {

    return (
        <div>
            <div>
                <Carousel dynamicHeight showArrows={false} showStatus={false} className="presentation-mode" showThumbs={false} autoPlay
                          interval={5000} infiniteLoop >
                    <div>
                        <img alt="Hector at Disney Conf. Room" className="image" src="assets/disney/1.png"/>
                    </div>
                    <div>
                        <img alt="Hector at Team Disney" className="image" src="assets/disney/2.png"/>
                    </div>
                    <div>
                        <img alt="Hector at Disney Filming" className="image" src="assets/disney/3.png"/>
                    </div>
                    <div>
                        <img alt="Hector at Disney Design Board" className="image" src="assets/disney/4.png"/>
                    </div>
                </Carousel>
            </div>
            <div className="content">
                <h1>Behind the Magic of Disney</h1>
                <p>I started working at Disney in 2008 as a Software Engineer, developing services for asset management systems. It was a great, but challenging, experience. I worked with teams all over the world, from North America, to LATAM in Buenos Aires, EMEA in London, and APAC in Singapore.</p>
                <p>At the end of my time at Disney, I was a lead developer for project Prometheous, which eventually became Watch ABC. This was the first Live Streaming Platform in the world. You would be able to watch the same content from your regular broadcaster in your mobile device.</p>
            </div>
        </div>
    );

}


// WEBPACK FOOTER //
// ./src/components/sections/Disney.jsx